import { type FC, useId } from 'react';

import { GenericMenuItem } from '@craft/ui/components/lists';

import { type CompetencyTag } from '../../types';

import { DisplayMenuItem } from './DisplayMenuItem';

interface CompetencyTagGroupProps {
  readonly groupName: string;
  readonly onTagClick: (tagId: string) => void;
  readonly selectedTags: string[];
  readonly tags: CompetencyTag[];
}

export const CompetencyTagGroup: FC<CompetencyTagGroupProps> = ({
  groupName,
  onTagClick,
  selectedTags,
  tags,
}) => {
  const groupId = useId();

  if (tags.length === 0) {
    return null;
  }

  return (
    <>
      <DisplayMenuItem component='li' id={groupId}>
        {groupName}
      </DisplayMenuItem>
      {tags.map(tag => (
        <GenericMenuItem
          aria-labelledby={`${groupId} ${tag.id}`}
          id={tag.id}
          isSelectable
          isSelected={selectedTags.includes(tag.id)}
          key={tag.id}
          onClick={() => onTagClick(tag.id)}
        >
          {tag.displayValue}
        </GenericMenuItem>
      ))}
    </>
  );
};
